export default "__VITE_ASSET__BVGrDRJV__"